import React from 'react';
import PropTypes from 'prop-types';
import getNavigation from './Navigations';

const NavigationContent = ({ className, navigationCollection, open }) => {
  const Navigation = getNavigation(navigationCollection?.resources().head());
  return (
    <Navigation
      className={className}
      navigationCollection={navigationCollection}
      open={open}
    />
  );
};

NavigationContent.defaultProps = {
  className: '',
  open: false,
};

NavigationContent.propTypes = {
  className: PropTypes.string,
  navigationCollection: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

export default NavigationContent;
